"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var PageListView_1 = __importDefault(require("./PageListView"));
var PageEditView_1 = __importDefault(require("./PageEditView"));
var PageDetailView_1 = __importDefault(require("./PageDetailView"));
var PagesPage = react_1.default.memo(function () { return react_1.default.createElement(react_router_dom_1.Routes, null,
    react_1.default.createElement(react_router_dom_1.Route, { path: "list", element: react_1.default.createElement(PageListView_1.default, null) }),
    react_1.default.createElement(react_router_dom_1.Route, { path: "edit/:id", element: react_1.default.createElement(PageEditView_1.default, null) }),
    react_1.default.createElement(react_router_dom_1.Route, { path: "detail/:id", element: react_1.default.createElement(PageDetailView_1.default, null) }),
    react_1.default.createElement(react_router_dom_1.Route, { path: "*", element: react_1.default.createElement(react_router_dom_1.Navigate, { to: "list", replace: true }) })); });
exports.default = PagesPage;
